const WORD = [ 'doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'epub', 'fb2', 'fodt', 'htm', 'html', 'hwp', 'hwpx', 'mht', 'mhtml', 'odt', 'ott', 'pages', 'rtf', 'stw', 'sxw', 'txt', 'wps', 'wpt', 'xml' ]
const CELL = [ 'csv', 'dif', 'fods', 'ods', 'ots', 'xls', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'xml' ]
const PDF = [ 'pdf', 'xps', 'oxps', 'djvu' ]

export const onlyOfficeDocumentTypes = {
    "word": WORD,
    "cell": CELL,
    "pdf": PDF,
}